import { useState, useEffect } from "react";

/**
 * Full-page black overlay that fades out to reveal content underneath.
 * Ensures the entire page (banners, text, everything) is hidden behind
 * a black screen that smoothly transitions to transparent.
 *
 * Place this as a sibling inside the outermost page container.
 */
export default function PageBlackOverlay({ duration = 1000, delay = 80 }) {
  const [fading, setFading] = useState(false);
  const [removed, setRemoved] = useState(false);

  useEffect(() => {
    const fadeTimer = setTimeout(() => setFading(true), delay);
    const removeTimer = setTimeout(() => setRemoved(true), delay + duration + 200);
    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(removeTimer);
    };
  }, [delay, duration]);

  if (removed) return null;

  return (
    <div
      data-testid="page-black-overlay"
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 99998,
        background: "#000",
        opacity: fading ? 0 : 1,
        transition: `opacity ${duration}ms ease`,
        pointerEvents: "none",
      }}
    />
  );
}
